import { getAddress } from '../address/getAddress.js';
import { isAddressEqual } from '../address/isAddressEqual.js';
import { recoverTypedDataAddress, } from './recoverTypedDataAddress.js';
export async function verifyTypedData({ address, domain, message, primaryType, signature, types, }) {
    return isAddressEqual(getAddress(address), await recoverTypedDataAddress({
        domain,
        message,
        primaryType,
        signature,
        types,
    }));
}
//# sourceMappingURL=verifyTypedData.js.map